import axios from 'axios'

const NETWORK_MESSAGE = 'No se pudo conectar con el servidor. Intente de nuevo.'

// Single result shape for every Xcalacoco action: { ok, httpStatus, code, message, data }
// eslint-disable-next-line import/prefer-default-export
export async function request(config) {
  try {
    const response = await axios(config)
    const body = response.data || {}
    return {
      ok: true,
      httpStatus: response.status,
      code: null,
      message: body.message || '',
      data: body.data,
    }
  } catch (error) {
    const response = error && error.response
    if (!response) {
      return {
        ok: false,
        httpStatus: 0,
        code: 'network',
        message: NETWORK_MESSAGE,
        data: null,
      }
    }
    const body = response.data || {}
    if (response.status === 401) {
      return {
        ok: false,
        httpStatus: 401,
        code: 'unauthorized',
        message: body.detail || '',
        data: null,
      }
    }
    return {
      ok: false,
      httpStatus: response.status,
      code: body.code || 'serverError',
      message: body.message || body.detail || '',
      data: body.data === undefined ? null : body.data,
    }
  }
}
